import { motion } from "framer-motion";
import { FadeUp, MaskLines, Em, Eyebrow } from "@/components/site/Motion";
import { MagneticButton } from "@/components/site/Magnetic";

const STEPS = [
  { t: "00:00", h: "the brief lands", b: "A form, an email, a call. However it arrives, the clock starts.", off: "" },
  { t: "≤ 01:00", h: "someone calls back", b: "A recruiter who's sat in technical interviews scopes the role with you. Proper questions, not a checklist.", off: "md:mt-20" },
  { t: "01–04", h: "we work the bench", b: "Warm network first: people we already know, already rate, already trust.", off: "md:mt-8" },
  { t: "≤ 05:00", h: "names on your desk", b: "A first shortlist: screened, interested, available. Small on purpose.", off: "md:mt-28" },
];

export const Play = () => (
  <section className="relative overflow-hidden px-5 py-24 sm:px-8 lg:py-36" data-testid="play-section">
    <div className="mx-auto max-w-[1400px]">
      <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
        <div>
          <Eyebrow className="text-[#c2380f]">the first five hours</Eyebrow>
          <MaskLines as="h2" lines={["one brief.", <>four moves. <Em className="text-[#2234F5]">no huddle.</Em></>]}
            className="font-display mt-6 text-4xl font-bold leading-[0.95] tracking-[-0.03em] sm:text-6xl" />
        </div>
        <MagneticButton to="/how-we-work" tone="ghost" testid="play-more-btn">see the full play</MagneticButton>
      </div>
      <div className="relative mt-16">
        <motion.div initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
          className="absolute left-0 right-0 top-[18px] hidden h-[2px] origin-left bg-[#0E0E10] md:block" />
        <div className="grid gap-12 md:grid-cols-4 md:gap-6">
          {STEPS.map((s, i) => (
            <FadeUp key={s.t} delay={0.2 + i * 0.15} className={`relative ${s.off}`} data-testid={`play-step-${i}`}>
              <span className={`font-mono-x relative z-10 inline-block rounded-full px-3 py-2 text-sm font-bold ${i === 3 ? "bg-[#FF4D1A] text-white" : "bg-[#0E0E10] text-[#F1ECE2]"}`}>{s.t}</span>
              <h3 className="font-display mt-6 text-2xl font-bold tracking-tight">{s.h}</h3>
              <p className="mt-3 max-w-[18rem] leading-relaxed text-[#3d3a35]">{s.b}</p>
            </FadeUp>
          ))}
        </div>
      </div>
    </div>
  </section>
);
